export { default } from "./ProductSpecification.jsx";
